module.exports = __webpack_public_path__ + "static/media/background_login.1d0695ac.jpg";